import React from 'react'
import { useTranslation, Trans } from 'react-i18next'
import { SectionShell } from '../shared/SectionShell'
import { FlowerOfLife } from '../shared/FlowerOfLife'
import { AccentText } from '../shared/AccentText'

const LINES = ['verse.l1', 'verse.l2', 'verse.l3', 'verse.l4', 'verse.l5']

export default function VerseSection() {
    const { t } = useTranslation()

    return (
        <SectionShell id="verse">
            <div className="verse-bg" aria-hidden="true">
                <FlowerOfLife size={460} className="verse-flower" />
            </div>

            <div className="verse-content">
                <div className="section-head">
                    <span className="section-num">03</span>
                    <span className="section-label">{t('verse.label')}</span>
                </div>

                <p className="verse-title">{t('verse.title')}</p>

                <div className="verse-lines">
                    {LINES.map((key, i) => {
                        const start = i * 0.06
                        return (
                            <div
                                key={key}
                                className="verse-line"
                                style={{ '--lp-start': start }}
                            >
                                <Trans
                                    i18nKey={key}
                                    components={{ accent: <AccentText /> }}
                                />
                            </div>
                        )
                    })}
                </div>
            </div>
        </SectionShell>
    )
}
